import * as ActionType from '../../constants/actionType';

const dummyUser = {
  id: '0',
  username: 'service',
  password: 'Formulatrix2019',
  name: 'service',
  email: 'service@gmail.com',
  isActive: true,
  isLogin: false,
  roleId: '0',
  role: null,
};

const initialState = {
  user: dummyUser,
  sessionId: null,
};

export default function sessionState(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_SESSION_USER:
      return {
        ...state,
        user: action.user,
      };
    case ActionType.SET_SESSION_ID:
      return {
        ...state,
        sessionId: action.id,
      };
    case ActionType.RESET_SESSION_STATE:
      return initialState;
    default:
      return state;
  }
}
